import { TPersonalPronoun } from "../services/api";

export const formatPronoun = (pronoun: TPersonalPronoun) => {
  const names: Record<TPersonalPronoun, string> = {
    none: "None",
    she: "She/Her",
    he: "He/Him",
    they: "They/Them",
    "non-binary": "Non-Binary",
  };

  return names[pronoun];
};
